module.exports = __webpack_public_path__ + "static/media/delivery_icon.b5dda259.svg";